import type { Track } from '@/lib/api/mock/voice/types'
import type { AudioPubItem } from '@/lib/api/models/audio'

export interface PlazaTrack extends Track {
  audioUrl: string
}

export const pubItemToPlazaTrack = (item: AudioPubItem): PlazaTrack => ({
  id: item.id,
  title: item.title,
  tag: item.engine,
  description: item.description,
  duration: 0,
  seed: item.id,
  audioUrl: item.audioUrl,
})
